import { Link } from "react-router-dom";
import { MapPin, Gift } from "lucide-react";
import { STATUS_LABELS, STATUS_BADGE } from "../lib/constants";
import BookCover from "./BookCover";
import { Badge } from "./ui/badge";

export default function BookCard({ book }) {
  return (
    <Link to={`/libro/${book.id}`} data-testid={`book-card-${book.id}`}
      className="group flex flex-col rounded-2xl border border-border bg-card overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:border-primary/40">
      <div className="relative aspect-[3/4] bg-muted overflow-hidden">
        <BookCover book={book} className="transition-transform duration-500 group-hover:scale-105" />
        <div className="absolute top-2 left-2 flex flex-col gap-1">
          {book.is_demo && <Badge className="bg-stone-900/80 text-white border-0 text-[10px] font-mono uppercase tracking-wider">Esempio</Badge>}
          {book.is_gift && <Badge className="bg-rose-100 text-rose-800 border-rose-300 dark:bg-rose-950 dark:text-rose-300"><Gift className="w-3 h-3 mr-1" />In regalo</Badge>}
        </div>
        <div className="absolute top-2 right-2">
          <Badge variant="outline" className={`text-[10px] ${STATUS_BADGE[book.status] || ""}`}>{STATUS_LABELS[book.status] || book.status}</Badge>
        </div>
      </div>
      <div className="p-4 flex flex-col gap-2 flex-1">
        <div className="flex-1">
          <h3 className="font-serif text-lg font-semibold leading-tight line-clamp-2 group-hover:text-primary transition-colors">{book.title}</h3>
          <p className="text-sm text-muted-foreground mt-0.5 line-clamp-1">{book.author}</p>
        </div>
        <div className="flex flex-wrap gap-1.5 pt-1">
          <Badge variant="secondary" className="text-[11px] font-normal">{book.genre}</Badge>
          <Badge variant="outline" className="text-[11px] font-normal">{book.condition}</Badge>
        </div>
        <div className="flex items-center gap-1 text-xs text-muted-foreground pt-1">
          <MapPin className="w-3.5 h-3.5" />{book.comune}
        </div>
      </div>
    </Link>
  );
}
